export const DemoColorsView = () => (
	<div className="is-page-pad-touch">
		<h2 className="mb-5 text-3xl text-center">Colors</h2>
	</div>
)
